import { HttpContextToken } from '@angular/common/http';

/**
 * Se true, l'interceptor loading non attiva l'overlay globale per questa richiesta.
 * Usato dal health check `/up` (Riprova connectivity).
 */
export const HTTP_SKIP_GLOBAL_LOADING = new HttpContextToken<boolean>(() => false);
